document.querySelector('.offers-drawer__heading').addEventListener('click', function() {
	if (document.getElementById('sidebar-cart').getAttribute('aria-hidden') == 'true') {
		document.querySelector('.offers-drawer').classList.toggle('open');
	}
});

const drawerSplide = document.querySelector('.offers-drawer-splide');
if (drawerSplide) {
	const blockCount = parseInt(drawerSplide.dataset.blockCount);
	let options = {
		perPage: blockCount,
		perMove: 1,
		arrows: false,
		pagination: false,
		drag: false,
		gap: 20,
		breakpoints: {
			1024: {
				perPage: 2,
			},
			767: {
				perPage: 1,
			}
		}
	}

	if (blockCount > 1) {
		options.breakpoints = {
			767: {
				perPage: 1,
				type: 'loop',
				autoWidth: true,
				padding: {
					right: '20%'
				}
			}
		}
	}

	const splide = new Splide('.offers-drawer-splide', options);
	splide.on( 'overflow', function ( isOverflow ) {
		if ( isOverflow ) {
			// Enough slides
		} else {
			// Not enough slides
		}
	});

	splide.mount();

	const offerLeft = document.querySelector('.offers-drawer-splide__arrow--left');
	const offerRight = document.querySelector('.offers-drawer-splide__arrow--right');

	if (offerLeft) {
		offerLeft.addEventListener('click', function() {
			splide.go('<');
		});
	}

	if (offerRight) {
		offerRight.addEventListener('click', function() {
			splide.go('>');
		});
	}
}
